import * as internalStyleHelper from '../../../helpers/internalstyle';

export const quizStyle = state => key => {
  const style = state.styles[key];
  return style ? style.rules : {};
};

export const quizInternalStyle = state => internalStyleHelper.getHtmlTag(state.styles);



/** WEBPACK FOOTER **
 ** ./src/store/modules/quiz/getters.js
 **/